module.exports = __webpack_public_path__ + "img/2.3f0f938b.jpg";